let filters = {
    category_slug: null,
    current_page: 1,
    per_page: 21,
    offset: 3,
};

$(document).ready(function () {
    handleLoadMoreNews();
});


function handleLoadMoreNews() {
    $('#btn-see-more-news').on('click', function () {
        getListExtend();
    });
}

function buildSearchUrl() {
    let url = null;
    let i = 0;

    const urlParams = new URLSearchParams(window.location.search);

    // Lấy giá trị của tham số 'category'
    filters.category_slug = urlParams.get('category')

    url = `${window.location.origin}/api/get-list-news-extend`;

    for (const item in filters) {
        url += `${i == 0 ? '?' : '&'}${item.replace('_', '-')}=${filters[item]}`
        i++;
    }

    return url;
}

function getListExtend() {
    if (filters.current_page != null) {
        filters.current_page = filters.current_page + 1
    }

    const url = buildSearchUrl();

    $.ajax({
        url,
        success: function (response) {
            console.log('response', response);

            if (response.status == 200) {
                filters.current_page = response.result.data.current_page;
                filters.per_page = response.result.data.per_page;


                if (response.result.data.data.length > 0) {
                    const html = templateContentSearch(response.result.data.data);

                    // $(document).find('.list-news .news-cpn').remove();

                    $('#list-news').append(html);
                } else {
                    $('#list-news').append(`
                        <p>Không có kết quả phù hợp</p>
                    `);
                }
                if (!response.result.has_next) {
                    $('.btn-box').remove();
                }
                $('#loading-box').addClass('d-none');
            }
        },
        error: function (error) {
            console.log("Has error when search");
        }
    });
}

function templateContentSearch(data) {
    let html = '';

    if (data.length > 0) {
        data.forEach((item, index, array) => {
            html += `
                   <div class="news-cpn">
                        <div class="news-cpn__image-box">
                            <a href="/tin-tuc?n=${item.category_slug}">
                                <img src="${item.avatar}" alt="image">
                            </a>
                        </div>
                        <div class="news-cpn__content">
                            <div>
                                <a href="/tin-tuc?category-slug=${item.category_slug}" class="category">
                                    ${item.category_name}
                                </a>
                                <a href="/tin-tuc?n=${item.id}" class="title">
                                    ${item.title}
                                </a>

                                <a href="/tin-tuc?n=${item.id}" class="describe">
                                    ${item.description}
                                </a>
                            </div>

                            <div class="info-cpn">
                                <div class="info-cpn__time-box">
                                    <svg class="clock" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Group 2102">
                                        <path id="Duo" fill-rule="evenodd" clip-rule="evenodd" d="M4.75 2.75C5.02614 2.75 5.25 2.97386 5.25 3.25V4.98241L6.52735 5.83397C6.75711 5.98715 6.8192 6.29759 6.66603 6.52735C6.51285 6.75711 6.20241 6.8192 5.97265 6.66603L4.47265 5.66603C4.33355 5.57329 4.25 5.41718 4.25 5.25V3.25C4.25 2.97386 4.47386 2.75 4.75 2.75Z" fill="#8D8D8D"/>
                                        <path id="Icon" fill-rule="evenodd" clip-rule="evenodd" d="M0.25 5.00011C0.25 2.3767 2.3767 0.25 5.00011 0.25C7.62352 0.25 9.75022 2.3767 9.75022 5.00011C9.75022 7.62352 7.62352 9.75022 5.00011 9.75022C2.3767 9.75022 0.25 7.62352 0.25 5.00011ZM5.00011 1.25C2.92898 1.25 1.25 2.92898 1.25 5.00011C1.25 7.07124 2.92898 8.75022 5.00011 8.75022C7.07124 8.75022 8.75022 7.07124 8.75022 5.00011C8.75022 2.92898 7.07124 1.25 5.00011 1.25Z" fill="#8D8D8D"/>
                                        </g>
                                    </svg>
                                    ${item.diff_for_humans}
                                </div>
                                <span class="dot-text">${item.public_date}</span>
                            </div>
                        </div>
                    </div>
            `;
        });
    }

    return html;
}
